import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import ".././../styles/diet/diet.css";
import { selectAuth } from "../../components/auth/auth.selector";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import IngredientsFilters from "../../components/diet/ingredients/IngredientsFilters";
import { fetchIngredientsData } from "../../redux/reducers/apiSlice";
import IngTable from "../../components/diet/ingredients/IngTable";
import HelmetWrapper from "../../HelmetWrapper";

const Ingredients = () => {
  const dispatch = useDispatch();
  const { ingData } = useSelector((state) => state.api);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const initialIngFilters = {
    searchString: "",
  };
  const [ingFilters, setIngFilters] = useState(initialIngFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState("");
  const ingredientsInitials = {
    isPage: 0,
    pagination: [],
    allIngData: [],
  };
  const [allIngredients, setAllIngredients] = useState(ingredientsInitials);

  const onClickSearch = () => {
    setSearchFilterApplied(true);
    const searchQP = ingFilters.searchString
      ? `&search=${ingFilters.searchString}`
      : "";

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  useEffect(() => {
    dispatch(
      fetchIngredientsData({
        pageNo: allIngredients.isPage + 1,
        limit: 10,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, allIngredients.isPage]);

  useEffect(() => {
    if (ingData?.status && ingData?.data?.length > 0) {
      const { data, pagination } = ingData || {};

      setAllIngredients({
        ...allIngredients,
        allIngData: data || [],
        pagination: pagination || [],
      });
    } else {
      setAllIngredients({
        ...allIngredients,
        allIngData: [],
        pagination: [],
      });
    }
  }, [ingData]);

  useEffect(() => {
    if (ingFilters.searchString?.length === 0) {
      dispatch(
        fetchIngredientsData({
          pageNo: allIngredients.isPage + 1,
          limit: 10,
          queryParameters: sendableQPs?.replace(/&?search=[^&]*/, ""),
          token: decryptedText?.token,
        })
      );
      setSearchFilterApplied(false);
    }
  }, [ingFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Diet Ingredients">
      <Container className="bg-cloud-k dietMealsParentContainer px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"All Ingredients"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <IngredientsFilters
              filters={ingFilters}
              setFilters={setIngFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              callFunction={() =>
                dispatch(
                  fetchIngredientsData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                )
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <IngTable
              decryptedText={decryptedText}
              allDatas={allIngredients}
              setAllDatas={setAllIngredients}
              callFunction={() => {
                dispatch(
                  fetchIngredientsData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                );

                setAllIngredients((prevs) => ({
                  ...prevs,
                  isPage: 0,
                  pagination: [],
                }));
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Ingredients;
